import React, { InputHTMLAttributes, ReactElement } from 'react'
import { FieldError, FieldValues, Path, UseFormRegister } from 'react-hook-form'
import classNames from 'classnames'

export type InputProps<TFieldValues extends FieldValues> = {
  register: UseFormRegister<TFieldValues>
  name: Path<TFieldValues>
  error?: FieldError
  suffix?: string
  prefix?: string
} & InputHTMLAttributes<HTMLInputElement>

export default function Input<TFieldValues extends FieldValues>({
  register,
  name,
  className,
  suffix,
  prefix,
  error,
  ...props
}: InputProps<TFieldValues>): ReactElement {
  return (
    <div className={'relative w-full'}>
      {prefix && (
        <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-500 sm:text-sm">
          {prefix}
        </span>
      )}
      <input
        id={name}
        {...register(name as Path<TFieldValues>)}
        className={classNames(
          className,
          'block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-emerald-600 sm:text-sm sm:leading-6',
          error
            ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500'
            : ''
        )}
        {...props}
      />
      {suffix && (
        <span className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-500 sm:text-sm">
          {suffix}
        </span>
      )}
    </div>
  )
}

Input.defaultProps = {
  type: 'text',
}
